<script setup lang="ts">
type Props = {
  reverse?: boolean;
};

const { reverse = false } = defineProps<Props>();

const datePeriod = defineModel<number | string>();

const { t } = useTexts();
const datePeriods = ref<TransactionPeriods[]>([
  { title: t('account.wallet.today'), value: 'today' },
  { title: t('account.wallet.yesterday'), value: 1 },
  { title: t('account.wallet.7_days'), value: 7 },
  { title: t('account.wallet.30_days'), value: 30 },
  { title: t('account.wallet.90_days'), value: 90 },
  { title: t('account.wallet.total'), value: 'all' },
]);
</script>

<template>
  <div :class="[$style.datePeriod, { [$style.reverse]: reverse }]">
    <label
      v-for="date in datePeriods"
      :key="date.value"
      :class="{ [$style.active]: datePeriod === date.value }"
      :for="`period_${date.value}`"
    >
      <input
        :id="`period_${date.value}`"
        v-model="datePeriod"
        type="radio"
        :value="date.value"
      />
      {{ date.title }}
    </label>
  </div>
</template>

<style module lang="scss">
.datePeriod {
  @apply flex items-center text-[.64rem] md:text-[.7rem] gap-2 whitespace-nowrap leading-4 text-primary;

  &.reverse {
    @apply flex-row-reverse;
  }

  label {
    @apply bg-primary/20 font-semibold relative px-1.5 py-0.5 md:px-2 md:py-1 rounded opacity-70 cursor-pointer;

    &.active {
      @apply opacity-100 bg-primary/90 text-bg-primary;
    }

    input {
      @apply absolute opacity-0 top-0 left-0;
    }
  }
}
</style>
